import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import './Login.css';

function Login({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [settings, setSettings] = useState({});
  const [rememberMe, setRememberMe] = useState(false);
  const [showForgotModal, setShowForgotModal] = useState(false);
  const [showSuspendedModal, setShowSuspendedModal] = useState(false);
  const [forgotEmail, setForgotEmail] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [capsLockOn, setCapsLockOn] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    axios.get('./backend/get_settings.php')
      .then(res => {
        // Lisans kontrolü: Eğer HTML dönerse (JSON değilse), sayfayı bu HTML ile değiştir
        if (typeof res.data === 'string' && (res.data.includes('<!DOCTYPE html>') || res.data.includes('Sistem Askıya Alındı'))) {
            document.documentElement.innerHTML = res.data;
            return;
        }
        setSettings(res.data || {});
      })
      .catch(err => console.error(err));

    const savedUsername = localStorage.getItem('remembered_username');
    if (savedUsername) {
      setUsername(savedUsername);
      setRememberMe(true);
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const response = await axios.post('./backend/login.php', {
        username,
        password
      });
      
      if (response.data.user) {
        onLogin(response.data.user, rememberMe);
        if (rememberMe) {
          localStorage.setItem('remembered_username', username);
        } else {
          localStorage.removeItem('remembered_username');
        }
        navigate('/dashboard');
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.message === 'CLINIC_SUSPENDED') {
        setShowSuspendedModal(true);
      } else {
        setError(err.response?.data?.message || 'Giriş başarısız. Lütfen bilgilerinizi kontrol edin.');
      }
      console.error(err);
    }
  };

  const handleKeyEvent = (e) => {
    setCapsLockOn(e.getModifierState('CapsLock'));
  };

  const handleForgotPassword = (e) => {
    e.preventDefault();
    axios.post('./backend/forgot_password.php', { email: forgotEmail })
      .then(res => {
        toast.success(res.data.message);
        setShowForgotModal(false);
        setForgotEmail('');
      })
      .catch(err => toast.error(err.response?.data?.message || "İşlem başarısız."));
  };

  return (
    <div className="login-container" style={{ backgroundImage: `url(${settings.login_background || 'https://images.unsplash.com/photo-1629909613654-28e377c37b09?q=80&w=2068&auto=format&fit=crop'})` }}>
      <div className="login-overlay"></div>
      <div className="login-box">
        <div className="login-header">
          {settings.clinic_logo && <img src={settings.clinic_logo} alt="Logo" className="login-logo" />}
          <h2>{settings.clinic_name || 'Dentis'}</h2>
          <p>Klinik Yönetim Sistemi</p>
        </div>
        
        {error && <p className="error-message">{error}</p>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Kullanıcı Adı</label>
            <input
              type="text"
              placeholder="Kullanıcı adınızı girin"
              value={username}
              onChange={(e) => { setUsername(e.target.value); setError(''); }}
              required
              className={error ? 'input-error' : ''}
            />
          </div>
          <div className="form-group">
            <label>Şifre</label>
            <div className="password-input-container">
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Şifrenizi girin"
                value={password}
                onChange={(e) => { setPassword(e.target.value); setError(''); }}
                onKeyUp={handleKeyEvent}
                onClick={handleKeyEvent}
                required
                className={error ? 'input-error' : ''}
              />
              <span className="password-toggle-icon" onClick={() => setShowPassword(!showPassword)}>
                {showPassword ? (
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path><line x1="1" y1="1" x2="23" y2="23"></line></svg>
                ) : (
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>
                )}
              </span>
            </div>
            {capsLockOn && (
              <div className="caps-lock-warning">
                ⚠️ Caps Lock açık
              </div>
            )}
          </div>
          <div className="form-options">
            <label className="remember-me">
              <input 
                type="checkbox" 
                checked={rememberMe} 
                onChange={(e) => setRememberMe(e.target.checked)} 
              />
              Beni Hatırla
            </label>
            <span className="forgot-password" onClick={() => setShowForgotModal(true)}>Şifremi Unuttum</span>
          </div>
          <button type="submit" className="login-btn">Giriş Yap</button>
        </form>
        <div style={{ marginTop: '25px', textAlign: 'center', fontSize: '0.7rem', color: '#a0a0a0', lineHeight: '1.4' }}>
            <p style={{ margin: 0 }}>Bu sistem zertucha.com tarafından lisanslanmıştır.</p>
            <p style={{ margin: 0 }}>Yazılımın izinsiz kopyalanması, dağıtılması veya tersine mühendislik işlemine tabi tutulması 5846 sayılı Fikir ve Sanat Eserleri Kanunu uyarınca suçtur ve yasal işlem gerektirir.</p>
        </div>
      </div>

      {/* Şifremi Unuttum Modalı */}
      {showForgotModal && (
        <div className="modal-overlay">
          <div className="modal" style={{ maxWidth: '400px' }}>
            <div className="modal-header">
              <h3>Şifre Sıfırlama</h3>
              <button className="close-modal-btn" onClick={() => setShowForgotModal(false)}>✕</button>
            </div>
            <div className="modal-body">
              <p style={{ marginBottom: '15px', color: '#5a5c69' }}>Kayıtlı e-posta adresinizi giriniz. Size bir sıfırlama bağlantısı göndereceğiz.</p>
              <form onSubmit={handleForgotPassword}>
                <div className="form-group">
                  <label>E-posta Adresi</label>
                  <input type="email" value={forgotEmail} onChange={e => setForgotEmail(e.target.value)} required placeholder="ornek@email.com" autoFocus />
                </div>
                <div className="modal-actions">
                  <button type="button" className="cancel-btn" onClick={() => setShowForgotModal(false)}>İptal</button>
                  <button type="submit" className="save-btn">Gönder</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* Klinik Pasif Modalı */}
      {showSuspendedModal && (
        <div className="modal-overlay">
          <div className="modal" style={{ maxWidth: '450px', textAlign: 'center' }}>
            <div className="modal-header" style={{ background: '#e74a3b', justifyContent: 'center' }}>
              <h3 style={{ color: 'white' }}>⚠️ Hizmet Kesintisi</h3>
            </div>
            <div className="modal-body">
              <p style={{ fontSize: '1.1rem', color: '#5a5c69', marginBottom: '20px' }}>
                Paket süreniz sona ermiştir.
              </p>
              <p style={{ fontWeight: 'bold', color: '#333' }}>Lütfen Sistem Yöneticiniz ile iletişime geçiniz.</p>
            </div>
            <div className="modal-actions" style={{ justifyContent: 'center' }}>
              <button type="button" className="save-btn" onClick={() => setShowSuspendedModal(false)} style={{ background: '#e74a3b' }}>Tamam</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Login;